<template>
	<div class="flex">
		<core-form-datepicker-input
			v-if="'custom' === filter"
			:openImmediate="true"
			:minDate="minDate"
			align="right"
			:dateRange="dateSelection"
			v-model="dateSelection"
		/>
		<core-dropdown-select align="right" :currentValue="dateText" :width="width">
			<template v-slot:list>
				<li v-if="includeAllTime"><a
					href="#"
					@click.prevent="$emit('quickSelect', '')"
					:class="{'current' : '' === filter}"
				>
					All Time
				</a></li>
				<li><a
					href="#"
					@click.prevent="$emit('quickSelect', '7-days')"
					:class="{'current' : '7-days' === filter}"
				>
					Last 7 Days
				</a></li>
				<li><a
					href="#"
					@click.prevent="$emit('quickSelect', '30-days')"
					:class="{'current' : '30-days' === filter}"
				>
					Last 30 Days
				</a></li>
				<li><a
					href="#"
					@click.prevent="$emit('quickSelect', 'custom')"
					:class="{'current' : 'custom' === filter}"
				>
					Custom Date Range
				</a></li>
			</template>
		</core-dropdown-select>
	</div>
</template>

<script>
export default {
	props : {
		filter : {
			type    : String,
			default : '',
		},
		minDate : {
			type    : Date,
			default : () => new Date(2013, 0), // When OM was started?!
		},
		/**
		 * Width
		 */
		width : {
			type    : Number,
			default : null,
		},
		includeAllTime : Boolean,
	},
	data () {
		return {
			dateSelection : [],
		}
	},
	watch : {
		dateSelection ([ start, end ]) {
			this.$emit('dateSelection', {
				filter : 'custom',
				start,
				end,
			})
		},
	},
	computed : {
		dateText () {
			switch (this.filter) {
			case '30-days':
				return 'Last 30 Days'
			case '7-days':
				return 'Last 7 Days'
			case 'custom':
				return 'Custom Date Range'
			}
			return this.includeAllTime ? 'All Time' : ''
		},
	},
}
</script>
